/**
 * Перевірка формату email (для валідації перед сабмітом форми).
 *
 * На відміну від `isValidEmailInput` з `inputValidation.js` (яка лише обмежує
 * символи під час набору тексту), ця функція перевіряє, що рядок має повний
 * та коректний формат адреси: `щось@домен.зона`.
 */

export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]+$/;

/**
 * Перевіряє, чи відповідає рядок формату email.
 *
 * @param {string} value — значення поля (пробіли по краях ігноруються)
 * @returns {boolean} `true`, якщо формат коректний
 *
 * @example
 * isValidEmailFormat('test@example.com'); // true
 * isValidEmailFormat('xcxx');              // false
 * isValidEmailFormat('test@example');      // false (немає зони)
 */
export const isValidEmailFormat = (value) => EMAIL_REGEX.test(value.trim());
